import React from "react";
import ReactMarkdown from 'react-markdown';

interface QuestionBlockProps {
  block: {
    name: string;
    defaultScore: number;
    questions: { text: string; score: number; notes: string }[];
  };
  questionIndex: number;
  onAnswer: (answer: boolean, score: number) => void;
}

const QuestionBlock: React.FC<QuestionBlockProps> = ({
  block,
  questionIndex,
  onAnswer,
}) => {
  if (!block || !block.questions || questionIndex >= block.questions.length) {
    return null; // Handle edge cases gracefully
  }

  const question = block.questions[questionIndex];

  return (
    <div className="question-block">
      <h2>{block.name}</h2>
      <ReactMarkdown>{question.text}</ReactMarkdown>
      {question.notes && question.notes.trim() !== "" && (
      <p style={{ fontSize: "small" }}><ReactMarkdown>{question.notes}</ReactMarkdown></p>
    )}
      <button onClick={() => onAnswer(true, question.score)}>Yes</button>
      <button onClick={() => onAnswer(false, question.score)}>No</button>
    </div>
  );
};

export default QuestionBlock;